"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dialog = void 0;
const Icon_1 = __importDefault(require("../Icon/Icon"));
const React = __importStar(require("react"));
const Theme_1 = require("../../Theme/Theme");
const DialogBackdrop = Theme_1.styled.div `
  align-items: center;
  background-color: ${(props) => props.theme.colors.black}80;
  display: flex;
  justify-content: center;
  visibility: ${(props) => (props.open ? 'visible' : 'hidden')};
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  position: fixed;
  z-index: 99999;
`;
const DialogContainer = Theme_1.styled.div `
  background-color: ${(props) => props.theme.white};
  border-radius: 4px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26), 0 2px 10px 0 rgba(0, 0, 0, 0.16);
  font-family: ${(props) => props.theme.font.family.proximaNova};
  padding: 64px;
  width: ${(props) => (props.width ? props.width : '600px')};
  color: ${(props) => props.theme.colors.gray[90]};
  opacity: 1;
  box-sizing: border-box;

  .close-icon {
    position: relative;
    float: right;
    top: -40px;
    right: -40px;
  }
`;
const DialogTitle = Theme_1.styled.div `
  font-size: 24px;
  letter-spacing: -0.13px;
  line-height: 29px;
  margin-bottom: ${(props) => (props.title ? '14px' : '0px')};
`;
const DialogContent = Theme_1.styled.div `
  font-size: 16px;
  letter-spacing: -0.1px;
  line-height: 30px;
  margin-bottom: 49px;

  img,
  iframe,
  video,
  object {
    max-width: 100%;
  }

  label {
    line-height: normal;
  }
`;
const DialogActions = Theme_1.styled.div ``;
exports.Dialog = (props) => {
    return (React.createElement(DialogBackdrop, { open: props.open, onClick: props.closeOnBackdropClick ? props.onClose : undefined },
        React.createElement(DialogContainer, { role: "dialog", width: props.width, onClick: (e) => e.stopPropagation() },
            props.onClose ? (React.createElement(Icon_1.default, { size: "16", icon: "close", "aria-label": "Close", onClick: props.onClose, className: "close-icon" })) : null,
            React.createElement(DialogTitle, { title: props.title }, props.title),
            React.createElement(DialogContent, { role: "document" }, props.content),
            React.createElement(DialogActions, null, props.actions))));
};
//# sourceMappingURL=Dialog.js.map